export enum AssessmentSubmitBtnType {
  QUIZ = "تسليم الإمتحان",
  HOMEWORK = "تسليم الواجب",
}

export enum AssessmentResultTextType {
  QUIZ = "درجتك في الكويز",
  HOMEWORK = "درجتك في الواجب",
}

export enum AssessmentMode {
  QUIZ = "quiz",
  HOMEWORK = "hw",
}

export enum VideoProvider {
  ELITE = "elite",
  BUNNY = "bunny",
  VIMEO = "vimeo",
}

export interface HomeworkData {
  score?: number;
  maxScore?: number;
  percentage?: number;
  isEnded: boolean;
  isStarted: boolean;
  questions: QuestionData[];
}

export type QuestionData = {
  question_id: number;
  question_type: string;
  title: string;
  content: string;
  img: string;
  weight: number;
  answers: string[];
  correct_answer: string;
  hint: string;
  userAnswer?: string;
  isCorrect?: boolean;
};

export type PastQuizTrial = {
  quiz_id: string[];
  quiz: string[];
  student: string[];
  student_id: string[];
  grade: string[];
  student_name: string[];
  date_submitted: string[];
  answers: string[];
  raw_data: string[];
  lesson_id: string[];
};

export type VideoData = {
  video_id: string;
  video_id2?: string;
  video_title: string;
  video_host?: VideoProvider;
};

export type LessonFile = {
  url: string;
  name: string;
  size: number;
  type: string;
};

export interface LessonDataI {
  is_purchased: boolean;
  lesson_id: number;
  title: string;
  date: string;
  price: number;
  lesson_videos: VideoData[];
  video_exist?: boolean;
  videos_data?: string;
  video_host?: string;
  quiz_id?: number;
  quiz_title?: string;
  hide_correct_answers?: boolean;
  must_answer_all?: boolean;
  quiz_duration?: number;
  quiz_questions?: QuestionData[];
  quiz_randomize?: boolean;
  quiz_trials?: number;
  quiz_required?: boolean;
  quiz_pass_grade?: string;
  hw_questions?: QuestionData[];
  hw_id?: number;
  hw_title?: string;
  hw_result?: string;
  hw_pass_grade?: string;
  lesson_files?: LessonFile[];
  views_notification_mark?: number;
  last_trial_date?: string;
  expiry_date?: number;
  remaining_views?: number;
  code?: boolean;
  wallet?: boolean;
  fawry?: boolean;
  vodafone_cash?: boolean;
  last_purchase_date?: string;
  pre?: number;
  prerequisite_type?: 'quiz' | 'hw';
  hw_raw_data?: string;
  newly_purchased?: boolean;
  is_author?: boolean;
  past_quiz_trials?: PastQuizTrial[];
  xvast_protection?: boolean;
  is_offline_purchase?: boolean;
  finished_prerequisites?: boolean;
  started_at?: string;
  join_token?: string;
}

export interface LiveSessionDataI {
  lesson_id: number;
  title: string;
  date: string;
  is_purchased: boolean;
  is_author: boolean;
  started_at: number;
  join_token?: string;
  price?: number;
  code?: boolean;
  wallet?: boolean;
  fawry?: boolean;
  vodafone_cash?: boolean;
  session_start_date?: string;
  session_duration?: number;
  is_ended?: boolean | null;
  current_server_time?: number;
}
